import React, { useEffect, useState } from 'react'
import { Grid } from '@mui/material'
import Banner from './Banner'
import { AxiosGet, ResultAPI } from 'service/CommonFunction/TS_function'
import News from './News';
import { currentLanguage } from 'service/CommonFunction/AxiosConfig';


const Home = () => {

    const [DataUser, setDataUser] = useState({
        "nUserID": null,
        "sUserCode": null,
        "sFullname": null,
        "sAPIRoleName": null,
        "sUserType": null,
        "lstCompany": [],
        "lstUserBA": []
    })


    useEffect(() => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth",
        });
    }, [])

    useEffect(() => {
        GetUserData();
    }, [])

    const GetUserData = async () => {
        AxiosGet("User/GetUserData", { "sLanguage": currentLanguage() }, (res) => {
            ResultAPI(res, null, () => {
                let lstIntBA = (res.result.lstUserBA || []).map(m => m.nBAID);
                setDataUser({
                    "nUserID": res.result.nUserID || "",
                    "sUserCode": res.result.sUserCode || "",
                    "sFullname": res.result.sFullname || "",
                    "sAPIRoleName": res.result.sAPIRoleName || "",
                    "sUserType": res.result.sUserType || "",
                    "lstCompany": res.result.lstCompany || [],
                    "lstUserBA": lstIntBA || [],
                });
            })
        })
    };

    return (
        <>
            <Banner DataUser={DataUser}/>
            <Grid container direction="row" justifyContent="center" alignItems="center">
                <Grid item xs={12}>
                    <News />
                </Grid>
            </Grid>
        </>
    )
}

export default Home